import { render, staticRenderFns } from "./RealTimeAlarm.vue?vue&type=template&id=60987b8a&scoped=true"
import script from "./RealTimeAlarm.vue?vue&type=script&lang=js"
export * from "./RealTimeAlarm.vue?vue&type=script&lang=js"
import style0 from "./RealTimeAlarm.vue?vue&type=style&index=0&id=60987b8a&prod&lang=scss"
import style1 from "./RealTimeAlarm.vue?vue&type=style&index=1&id=60987b8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60987b8a",
  null
  
)

export default component.exports